package one.healthium.uscreen.ui.text

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.sp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.uscreen.domain.models.StyledTextModel
import one.healthium.uscreen.domain.models.UScreenFontWeight
import one.healthium.uscreen.ui.util.parseHexColor

@Composable
fun StyledTextModel.toAnnotatedString(
    defaultColor: Color = Color.Unspecified,
): AnnotatedString {
    val primary = AppTheme.colors.primary
    val textSecondary = AppTheme.colors.text300

    return remember(this, defaultColor, primary, textSecondary) {
        buildAnnotatedString {
            segments.forEach { segment ->
                when (segment) {
                    is StyledTextModel.StyledSegment.Plain -> append(segment.text)
                    is StyledTextModel.StyledSegment.Styled -> {
                        val color = segment.color?.let {
                            resolveColor(it, primary, textSecondary)
                        } ?: defaultColor
                        val bgColor = segment.bg?.let {
                            resolveColor(it, primary, textSecondary)
                        }
                        withStyle(
                            SpanStyle(
                                color = color,
                                fontWeight = segment.fontWeight?.toComposeFontWeight(),
                                fontSize = segment.size?.sp ?: SpanStyle().fontSize,
                                textDecoration = if (segment.strike) TextDecoration.LineThrough else null,
                                background = bgColor ?: Color.Unspecified,
                            ),
                        ) {
                            append(segment.text)
                        }
                    }
                }
            }
        }
    }
}

private fun resolveColor(
    value: String,
    primary: Color,
    textSecondary: Color,
): Color? = when (value) {
    "primary" -> primary
    "textSecondary" -> textSecondary
    "white" -> Color.White
    "black" -> Color.Black
    else -> parseHexColor(value)
}

private fun UScreenFontWeight.toComposeFontWeight(): FontWeight = when (this) {
    UScreenFontWeight.Normal -> FontWeight.Normal
    UScreenFontWeight.Bold -> FontWeight.Bold
    UScreenFontWeight.SemiBold -> FontWeight.SemiBold
}
